/**
 * INS UGC 卡片网格 — 弹窗播放 / 封面 LQIP / 滑动防误开
 */
(function () {
  if (customElements.get("ins-ugc-grid")) return;

  function parseVideoUrl(url) {
    if (!url) return null;
    var yt = url.match(/(?:youtube\.com\/(?:watch\?(?:[^#]*&)?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    if (yt) {
      var ytId = yt[1];
      return {
        type: "iframe",
        provider: "youtube",
        ytId: ytId,
        poster: "https://i.ytimg.com/vi/" + ytId + "/hqdefault.jpg",
        posterLqip: "https://i.ytimg.com/vi/" + ytId + "/mqdefault.jpg",
        embedUrl: "https://www.youtube.com/embed/" + ytId + "?autoplay=1&mute=1&playsinline=1&rel=0&controls=0&modestbranding=1&enablejsapi=1",
      };
    }
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return { type: "iframe", provider: "vimeo", embedUrl: "https://player.vimeo.com/video/" + vm[1] + "?autoplay=1&playsinline=1" };
    var ig = url.match(/instagram\.com\/(?:[\w.]+\/)?(p|reel|reels|tv)\/([A-Za-z0-9_-]+)/i);
    if (ig) {
      var igPath = ig[1] === "reel" || ig[1] === "reels" ? "reel" : "p";
      return {
        type: "iframe",
        provider: "instagram",
        embedUrl: "https://www.instagram.com/" + igPath + "/" + ig[2] + "/embed/?hidecaption=1&cr=1",
        igKind: ig[1],
        igId: ig[2],
      };
    }
    var tt = url.match(/tiktok\.com\/@[^/]+\/video\/(\d+)/);
    if (tt) return { type: "iframe", provider: "tiktok", embedUrl: "https://www.tiktok.com/embed/v2/" + tt[1] };
    if (/\.(mp4|webm|ogg|mov)(\?|$)/i.test(url)) return { type: "video", provider: "file", embedUrl: url };
    return { type: "iframe", provider: "fallback", embedUrl: url };
  }

  function resolvePoster(card, parsed) {
    if (card && card.poster) return { hd: card.poster, lqip: card.posterLqip || card.poster };
    if (parsed && parsed.poster) return { hd: parsed.poster, lqip: parsed.posterLqip || parsed.poster };
    return { hd: "", lqip: "" };
  }

  function label(root, key, fallback) {
    return (root && root.dataset && root.dataset[key]) || fallback;
  }

  class InsUgcGrid extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector("[data-dialog]");
      this.mediaEl = this.querySelector("[data-dialog-media]");
      this.titleEl = this.querySelector("[data-dialog-title]");
      this.descEl = this.querySelector("[data-dialog-desc]");
      this.track = this.querySelector("[data-track]");
      this.cards = this.readCards();
      this.swipeGuard = { moved: false, startX: 0 };
      if (!this.dialog || !this.mediaEl) return;

      this.bindDialog();
      this.bindCards();
      this.bindThumbs();
      this.syncResponsiveLayers();
      var self = this;
      this._mq = window.matchMedia("(max-width: 767px)");
      this._onMq = function () { self.syncResponsiveLayers(); };
      if (this._mq.addEventListener) this._mq.addEventListener("change", this._onMq);
      else this._mq.addListener(this._onMq);
    }

    disconnectedCallback() {
      if (this._mq && this._onMq) {
        if (this._mq.removeEventListener) this._mq.removeEventListener("change", this._onMq);
        else this._mq.removeListener(this._onMq);
      }
      this.clearMedia();
    }

    syncResponsiveLayers() {
      var isMobile = window.matchMedia("(max-width: 767px)").matches;
      var grid = this.querySelector(".ins-ugc-grid__grid");
      var carousel = this.querySelector(".ins-ugc-grid__carousel");
      if (grid) {
        grid.toggleAttribute("inert", isMobile);
        grid.setAttribute("aria-hidden", isMobile ? "true" : "false");
      }
      if (carousel) {
        carousel.toggleAttribute("inert", !isMobile);
        carousel.setAttribute("aria-hidden", isMobile ? "false" : "true");
      }
    }

    readCards() {
      var node = this.querySelector("script[type='application/json'][data-cards]");
      if (!node) return [];
      try {
        var data = JSON.parse(node.textContent);
        return Array.isArray(data) ? data : [];
      } catch (err) {
        return [];
      }
    }

    liveThumbSrc(idx) {
      var best = "";
      this.querySelectorAll('[data-card-index="' + idx + '"]').forEach(function (cardBtn) {
        if (cardBtn.closest("[inert]")) return;
        var lqip = cardBtn.querySelector(".ins-ugc-grid__thumb-lqip");
        var main = cardBtn.querySelector(".ins-ugc-grid__thumb-main");
        var src = (lqip && (lqip.currentSrc || lqip.src)) || (main && (main.currentSrc || main.src)) || "";
        if (src) best = src;
      });
      return best;
    }

    clearMedia() {
      if (!this.mediaEl) return;
      var iframe = this.mediaEl.querySelector("iframe");
      if (iframe) iframe.src = "";
      var video = this.mediaEl.querySelector("video");
      if (video) {
        video.pause();
        video.src = "";
      }
      this.mediaEl.classList.remove("is-embed-ready", "is-instagram", "is-scrollable");
      this.unobserveIgMedia();
      this.unbindIgScrollLock();
      this.mediaEl.innerHTML = "";
    }

    hideDialogPoster() {
      this.mediaEl.classList.add("is-embed-ready");
    }

    bindIgScrollLock() {
      var el = this.mediaEl;
      if (!el || this._igScrollLock) return;
      this._igScrollLock = function (e) {
        e.preventDefault();
      };
      el.addEventListener("wheel", this._igScrollLock, { passive: false });
      el.addEventListener("touchmove", this._igScrollLock, { passive: false });
    }

    unbindIgScrollLock() {
      var el = this.mediaEl;
      if (!el || !this._igScrollLock) return;
      el.removeEventListener("wheel", this._igScrollLock);
      el.removeEventListener("touchmove", this._igScrollLock);
      this._igScrollLock = null;
    }

    syncIgScrollMode() {
      var media = this.mediaEl;
      if (!media || !media.classList.contains("is-instagram")) return;
      var allow = media.getBoundingClientRect().height < 500;
      media.classList.toggle("is-scrollable", allow);
      if (allow) this.unbindIgScrollLock();
      else this.bindIgScrollLock();
    }

    observeIgMedia() {
      this.unobserveIgMedia();
      var self = this;
      if (this.mediaEl && "ResizeObserver" in window) {
        this._igResizeObs = new ResizeObserver(function () {
          self.syncIgScrollMode();
        });
        this._igResizeObs.observe(this.mediaEl);
      }
      this.syncIgScrollMode();
    }

    unobserveIgMedia() {
      if (this._igResizeObs) {
        this._igResizeObs.disconnect();
        this._igResizeObs = null;
      }
    }

    appendDialogPoster(card, idx, parsed) {
      var resolved = resolvePoster(card, parsed);
      var hdUrl = resolved.hd;
      var lqipUrl = this.liveThumbSrc(idx) || resolved.lqip;
      if (!hdUrl && !lqipUrl) return null;

      var wrap = document.createElement("div");
      wrap.className = "ins-ugc-grid__dialog-poster-wrap";

      if (lqipUrl) {
        var lqip = document.createElement("img");
        lqip.className = "ins-ugc-grid__dialog-poster-lqip";
        lqip.src = lqipUrl;
        lqip.alt = "";
        lqip.setAttribute("aria-hidden", "true");
        lqip.decoding = "async";
        lqip.loading = "eager";
        wrap.appendChild(lqip);
      }

      if (hdUrl) {
        var hd = document.createElement("img");
        hd.className = "ins-ugc-grid__dialog-poster-hd";
        hd.src = hdUrl;
        hd.alt = "";
        hd.setAttribute("aria-hidden", "true");
        hd.decoding = "async";
        var markHd = function () {
          wrap.classList.add("is-hd-loaded");
        };
        if (hd.complete && hd.naturalWidth > 0) markHd();
        else hd.addEventListener("load", markHd, { once: true });
        wrap.appendChild(hd);
      }

      this.mediaEl.appendChild(wrap);
      return wrap;
    }

    mediaTitle(card, parsed) {
      var name = (card && card.title) || "";
      if (parsed && parsed.provider === "youtube") {
        return name || label(this, "i18nYoutube", "YouTube");
      }
      if (parsed && parsed.provider === "instagram") {
        return name || label(this, "i18nInstagram", "Instagram");
      }
      return name || label(this, "i18nPlay", "Video");
    }

    openCard(idx) {
      var c = this.cards[idx];
      if (!c) return;

      if (this.titleEl) this.titleEl.textContent = c.title;
      if (this.descEl) this.descEl.textContent = c.desc;
      if (this.dialog) {
        if (this.titleEl && c.title) this.dialog.setAttribute("aria-labelledby", this.titleEl.id);
        else this.dialog.setAttribute("aria-label", label(this, "i18nDialog", "Media"));
        if (this.descEl && c.desc) this.dialog.setAttribute("aria-describedby", this.descEl.id);
        else this.dialog.removeAttribute("aria-describedby");
      }

      this.clearMedia();

      var parsed = parseVideoUrl(c.videoUrl);
      var self = this;
      var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (parsed) {
        if (parsed.type === "iframe") {
          var posterWrap = this.appendDialogPoster(c, idx, parsed);
          if (parsed.provider === "instagram") {
            this.mediaEl.classList.add("is-instagram");
            if (!posterWrap) {
              posterWrap = document.createElement("div");
              posterWrap.className = "ins-ugc-grid__dialog-poster-wrap";
              this.mediaEl.appendChild(posterWrap);
            }
            posterWrap.classList.add("is-loading");
            var loader = document.createElement("div");
            loader.className = "ins-ugc-grid__dialog-loader";
            loader.setAttribute("aria-hidden", "true");
            posterWrap.appendChild(loader);
          }
          var iframe = document.createElement("iframe");
          iframe.allow = "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media";
          iframe.allowFullscreen = true;
          iframe.frameBorder = "0";
          iframe.scrolling = "no";
          iframe.setAttribute("scrolling", "no");
          iframe.title = this.mediaTitle(c, parsed);
          iframe.className = "ins-ugc-grid__dialog-iframe";
          if (parsed.provider === "instagram") iframe.classList.add("is-instagram");
          iframe.addEventListener("load", function () {
            var src = iframe.src || "";
            if (src && src !== "about:blank") self.hideDialogPoster();
          });
          this.mediaEl.appendChild(iframe);
          iframe.src = parsed.embedUrl;
        } else {
          var fileVid = document.createElement("video");
          fileVid.src = parsed.embedUrl;
          fileVid.controls = true;
          fileVid.playsInline = true;
          fileVid.setAttribute("playsinline", "");
          fileVid.setAttribute("webkit-playsinline", "");
          fileVid.autoplay = !reducedMotion;
          fileVid.muted = true;
          fileVid.preload = "metadata";
          fileVid.poster = resolvePoster(c, parsed).hd;
          fileVid.setAttribute("title", this.mediaTitle(c, parsed));
          fileVid.className = "ins-ugc-grid__dialog-video";
          this.mediaEl.appendChild(fileVid);
          this.appendDialogPoster(c, idx, parsed);
          fileVid.addEventListener("playing", function () {
            self.hideDialogPoster();
          }, { once: true });
          if (!reducedMotion) fileVid.play().catch(function () {});
        }
      } else if (c.sources && c.sources.length) {
        var localVid = document.createElement("video");
        localVid.controls = true;
        localVid.playsInline = true;
        localVid.setAttribute("playsinline", "");
        localVid.setAttribute("webkit-playsinline", "");
        localVid.autoplay = !reducedMotion;
        localVid.muted = true;
        localVid.preload = "metadata";
        localVid.poster = resolvePoster(c, null).hd;
        localVid.setAttribute("title", this.mediaTitle(c, null));
        localVid.className = "ins-ugc-grid__dialog-video";
        c.sources.forEach(function (s) {
          var src = document.createElement("source");
          src.src = s.url;
          src.type = s.type;
          localVid.appendChild(src);
        });
        this.mediaEl.appendChild(localVid);
        this.appendDialogPoster(c, idx, null);
        localVid.addEventListener("playing", function () {
          self.hideDialogPoster();
        }, { once: true });
        localVid.load();
        if (!reducedMotion) localVid.play().catch(function () {});
      } else if (c.poster) {
        var img = document.createElement("img");
        img.src = c.poster;
        img.alt = c.title || "";
        img.className = "ins-ugc-grid__dialog-cover";
        this.mediaEl.appendChild(img);
      }

      this.openDialog();
    }

    openDialog() {
      this.dialog.classList.add("is-pointer-open");
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
      if (typeof this.dialog.showModal === "function") this.dialog.showModal();
      else this.dialog.setAttribute("open", "");
      this.settlePointerDialogFocus();
      var self = this;
      requestAnimationFrame(function () {
        self.observeIgMedia();
      });
    }

    settlePointerDialogFocus() {
      var dialog = this.dialog;
      if (!dialog) return;
      var closeBtn = dialog.querySelector("[data-dialog-close]");
      var focusDialog = function () {
        if (closeBtn && document.activeElement === closeBtn) closeBtn.blur();
        try {
          dialog.focus({ preventScroll: true });
        } catch (_) {
          dialog.focus();
        }
      };
      focusDialog();
      requestAnimationFrame(focusDialog);
    }

    closeDialog() {
      this.clearMedia();
      if (typeof this.dialog.close === "function") this.dialog.close();
      else this.dialog.removeAttribute("open");
    }

    bindDialog() {
      var self = this;
      var closeBtn = this.dialog.querySelector("[data-dialog-close]");
      if (closeBtn) closeBtn.addEventListener("click", function () { self.closeDialog(); });
      this.dialog.addEventListener("click", function (e) {
        if (e.target === self.dialog) self.closeDialog();
      });
      this.dialog.addEventListener("close", function () {
        self.dialog.classList.remove("is-pointer-open");
        self.clearMedia();
      });
      this.dialog.addEventListener("keydown", function (e) {
        if (e.key === "Tab") self.dialog.classList.remove("is-pointer-open");
      });
    }

    bindCards() {
      var self = this;
      if (this.track) {
        this.track.addEventListener("pointerdown", function (e) {
          self.swipeGuard.startX = e.clientX;
          self.swipeGuard.moved = false;
        }, { passive: true });
        this.track.addEventListener("pointermove", function (e) {
          if (Math.abs(e.clientX - self.swipeGuard.startX) > 8) self.swipeGuard.moved = true;
        }, { passive: true });
        this.track.addEventListener("scroll", function () {
          self.swipeGuard.moved = true;
        }, { passive: true });
      }

      this.querySelectorAll("[data-card-index]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (self.track && btn.closest(".ins-ugc-grid__carousel") && self.swipeGuard.moved) return;
          self.openCard(parseInt(btn.dataset.cardIndex, 10));
        });
      });
    }

    bindThumbs() {
      this.querySelectorAll(".ins-ugc-grid__thumb-main").forEach(function (img) {
        var thumb = img.closest(".ins-ugc-grid__thumb");
        if (!thumb) return;
        var markLoaded = function () {
          thumb.classList.add("is-poster-loaded");
        };
        if (img.complete && img.naturalWidth > 0) markLoaded();
        else img.addEventListener("load", markLoaded, { once: true });
      });
    }
  }

  customElements.define("ins-ugc-grid", InsUgcGrid);
})();
